import React, { useState, useEffect, useContext } from "react";
import styles from "./style.module.scss";

import img from "../assets/image/cosmo.png";

import { MainContext } from "../context/MainContext";
import UsersAction from "../components/UsersAction/UsersAction";

function About() {
  const { user } = useContext(MainContext);
  const [currentNumber, setCurrentNumber] = useState(0);
  const [glitchAnimation, setGlitchAnimation] = useState(false);
  const [animatedLetters, setAnimatedLetters] = useState([]);
  const [text] = useState("PAGE NOT FOUND");

  const [targetNumber] = useState(404);
  const [duration] = useState(5000);
  const [durationText] = useState(5);

  useEffect(() => {
    const letters = text.split("").map((char, index) => ({
      char,
      id: index,
      randomX: Math.random() * 300 - 100,
      randomY: Math.random() * 300 - 100,
      delay: (durationText / text.length) * index,
    }));
    setAnimatedLetters(letters);
  }, [text, durationText]);

  useEffect(() => {
    const stepTime = Math.ceil(duration / targetNumber);
    let current = 0;

    const interval = setInterval(() => {
      if (current > targetNumber) {
        clearInterval(interval);
        setGlitchAnimation(true);
      } else {
        setCurrentNumber(current);
        current++;
      }
    }, stepTime);

    return () => clearInterval(interval);
  }, [targetNumber, duration]);

  return (
    <>
      {user?.role !== "admin" ? (
        <div className={styles.not_page}>
          <div className={styles.not_page__title__box}>
            <h2 className={styles.not_page__title}>Oooops!</h2>
          </div>
          <div className={styles.not_page__counter}>
            <span
              data-text={targetNumber}
              className={`${styles.not_page__number} ${
                glitchAnimation ? styles.not_page__glitch : ""
              }`}
            >
              {currentNumber}
            </span>
          </div>
          <div className={styles.not_page__text_container}>
            {glitchAnimation &&
              animatedLetters.map(({ char, id, randomX, randomY, delay }) => (
                <span
                  key={id}
                  className={styles.not_page__text_letter}
                  style={{
                    animationDelay: `${delay}s`,
                    "--randomX": `${randomX}%`,
                    "--randomY": `${randomY}%`,
                  }}
                >
                  {char === " " ? "\u00A0" : char}
                </span>
              ))}
          </div>
          <div className={styles.not_page__footer}>
            {glitchAnimation && (
              <p className={styles.not_page__footer__text}>
                The page you are looking for does not exist
              </p>
            )}
          </div>
          <img style={{ width: "250px" }} src={img} alt="cosmos" />
        </div>
      ) : (
        <UsersAction />
      )}
    </>
  );
}

export default About;
